import { render, staticRenderFns } from "./FormNewDriver.vue?vue&type=template&id=5c48d6b9&"
import script from "./FormNewDriver.vue?vue&type=script&lang=js&"
export * from "./FormNewDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports